import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./plugins/firebase";
import DatetimePicker from "vuetify-datetime-picker";

Vue.config.productionTip = false;

let app = null;
onAuthStateChanged(auth, (user) => {
  if (!app) {
    if (user) {
      store.commit("USER_AUTH_SUCCESS", user);
    }
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
});

Vue.use(DatetimePicker);
